// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'Vuex';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import VueAxios from 'vue-axios';
import Router from 'vue-router';
import UseElement from './ElmentUI';
import App from './App';
import CreateRouter from './router';
import CreateStore from './store';
import CreateApi from './api';
import CreateUtils from './utils';
import CreateDirective from './directive';
import 'mint-ui/lib/style.css';
import './assets/js/visualTimeSelector/index.css';
import {
  Button,
  Field,
  Radio,
  Toast,
  Checklist,
  DatetimePicker,
  Popup
} from 'mint-ui';
Vue.component(Button.name, Button);
Vue.component(Field.name, Field);
Vue.component(Radio.name, Radio);
Vue.component(Toast.name, Toast);
Vue.component(Checklist.name, Checklist);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Popup.name, Popup);

// utils
CreateUtils(Vue)

//多语言解决
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'EN',
  messages: {
    'CN': {
      message: {
        language: '测试'
      }
    }
  },
  messages: {
    'CN': require('./i18n/cn/index.js'),
    'EN': require('./i18n/en/index.js')
  }
})

// vuex
Vue.use(Vuex)
const store = CreateStore(Vuex, Vue)

// axois
Vue.use(VueAxios, axios)
CreateApi(Vue, axios)

// Vue-router
Vue.use(Router)
const router = CreateRouter(Router, store, Vue)


// element
UseElement(Vue)

// directive
CreateDirective(Vue)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js